import * as transSummaryByBuildingActions from '../actions/trans-summary-by-building.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface TransSummaryByBuildingState {
    transSummaryByBuilding: any;
    loading: boolean;
    loaded: boolean;
}

const initialState = {
    transSummaryByBuilding: null,
    loading: false,
    loaded: false
};

export const transSummaryByBuildingReducer = (state = initialState, action) => {
    switch(action.type){
        case transSummaryByBuildingActions.GET_TRANS_SUMMARY_BY_BUILDING_LIST:
            return {
                ...state,
                loading: true,
                loaded: state.loaded
            };
        case transSummaryByBuildingActions.GET_TRANS_SUMMARY_BY_BUILDING_LIST_SUCCESS:
            return {
                ...state,
                transSummaryByBuilding: action.payload,
                loading: false,
                loaded: true,
            };
        case transSummaryByBuildingActions.GET_TRANS_SUMMARY_BY_BUILDING_LIST_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
                loaded: false
            };
        case transSummaryByBuildingActions.CLEAR_TRANS_SUMMARY_BY_BUILDING_LIST:
            return {
                ...state,
                error: null,
                transSummaryByBuilding: null,
                loading: false,
                loaded: false
            };
        default:
            return state;
    }
};

export const getTransSummaryByBuildingState = createFeatureSelector<TransSummaryByBuildingState>('transSummaryByBuildingReducer');

export const getTransSummaryByBuildingList = (state: TransSummaryByBuildingState) => state.transSummaryByBuilding;
export const getTransSummaryByBuildingListLoaded = (state: TransSummaryByBuildingState) => state.loaded;
